import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
export function usePathMatch({ exact, path: pathProp }) {
    const location = useLocation();
    const paths = useMemo(() => (Array.isArray(pathProp) ? pathProp : [pathProp]).map((path) => ({
        path: exact ? path : `${path}/*`,
    })), [exact, pathProp]);
    const match = useMemo(() => !!matchRoutes(paths, location), [location, paths]);
    return match;
}
